/**
 * Session route helpers for MobileShell: the room views that own their own
 * fullscreen design and render without the phone chrome.
 */
const SESSION_PRESENT_RE = /^\/prioritization\/sessions\/[^/]+\/present$/;
const SESSION_TV_RE = /^\/prioritization\/sessions\/[^/]+\/tv$/;

export function isSessionPresentPath(pathname: string): boolean {
  return SESSION_PRESENT_RE.test(pathname);
}

export function isSessionTvPath(pathname: string): boolean {
  return SESSION_TV_RE.test(pathname);
}
